ACDiscountApp.PDPage.DisplayTiers = function () {
  
  var storeTime = globalFields.Storetime();
  // Parse the date string into individual components
   let [currentYear, currentMonth, currentDay, currentHours, currentMinutes, currentSeconds] = storeTime.split(/[\sT:-]/);
   currentYear = parseInt(currentYear);
   currentMonth = parseInt(currentMonth); // Months are zero-based in JavaScript
   currentDay = parseInt(currentDay);
   currentHours = parseInt(currentHours);
   currentMinutes =parseInt(currentMinutes);
   currentSeconds = parseInt(currentSeconds);

    function makeTimer(end_date) {
      if(globalFields.isProduct_Page){
        if(end_date != null){
        jQuery("#ac_countDown").css("display", "block");
          var endTime =  end_date;
        // Increment seconds by 1
         currentSeconds++;
        
        // Adjust minutes, hours, and day if necessary
        if (currentSeconds >= 60) {
            currentSeconds = 0;
            currentMinutes++;
            if (currentMinutes >= 60) {
                currentMinutes = 0;
                currentHours++;
                if (currentHours >= 24) {
                    currentHours = 0;
                    currentDay++;
                }
            }
        }
        
            // Reformat the updated timestamp
            let currentStoreTime = `${currentYear}-${currentMonth.toString().padStart(2, '0')}-${currentDay.toString().padStart(2, '0')}T${currentHours.toString().padStart(2, '0')}:${currentMinutes.toString().padStart(2, '0')}:${currentSeconds.toString().padStart(2, '0')}`;
            endTime = (Date.parse(endTime) / 1000);
            var now = currentStoreTime;
            now = (Date.parse(now) / 1000);
          
            var timeLeft = endTime - now;
            var days = Math.floor(timeLeft / 86400); 
            var hours = Math.floor(timeLeft / 3600);
            var exactHour = hours % 24;
            var minutes = Math.floor((timeLeft - (hours * 3600 )) / 60);
            var seconds = Math.floor((timeLeft - (hours * 3600) - (minutes * 60)));
            var isDays = false;
            if (days > 0 || hours > 24){isDays = true;}
            if (days < 0) { days = "00"; /*hours = "0"; minutes = "0"; seconds = "0";*/ }
            if (hours < 10) { hours = "0" + hours; }
            if (minutes < 10) { minutes = "0" + minutes; }
            if (seconds < 10) { seconds = "0" + seconds; }
            if(timeLeft > 0){
              if(isDays){
                $(".ac__days").html(days); $(".ac__hours").html(exactHour); $(".ac__minutes").html(minutes);
                $(".ac_sec, .ac__colon.seconds").hide();
              }
              else{
                $(".ac__hours").html(exactHour); $(".ac__minutes").html(minutes); $(".ac__seconds").html(seconds);		
                $(".ac_day, .ac__colon.hours").hide(); $(".ac_sec, .ac__colon.seconds").show();
              }
            }
            else{jQuery('.ac__settings__table, #ac_countDown').remove();}
          
          setTimeout(function () {
            jQuery('.ac__settings__table').after(jQuery("#ac_countDown"));
          }, 500);
        }
      }
  }   


  var hide_buttons = null;
  var HideAdditionalPayments = function() {      
    hide_buttons = setInterval(function() {
      if(jQuery('.shopify-payment-button__button').length>0){
        jQuery('.shopify-payment-button__button').hide();
        clearInterval(hide_buttons);
      }
    }, 500);
  }

  this.DisplayTiersFn = function () {
    setTimeout(function () {
       
        jQuery('.ac__settings__table').remove();
        var selectedVariant = jQuery('input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]', jQuery('form[action="/cart/add"]')).val();
        let ProductPage = globalFields.TableProductPage != undefined && globalFields.TableProductPage !=  '' ? globalFields.TableProductPage : 'true';
       ProductPage =  ProductPage == 'true' ? true: false;
        // ProductPage = true;
       if (selectedVariant != null && globalFieldsProductPage_AC.productMetafield != '[]' && globalFieldsProductPage_AC.productMetafield != undefined && ProductPage) {
         let tierObj = globalFields.GetTierObject(globalFieldsProductPage_AC.productMetafield, selectedVariant);
         let DiscountAppliedOn = false;
          let Location_Tag_s  = false;
         if(tierObj != undefined){
          let DiscountAppliedOn = tierObj.DiscountAppliedON != null &&  tierObj.DiscountAppliedON  != '' &&  tierObj.DiscountAppliedON != undefined ? true : false;
         let Location_Tag_s = tierObj.Location_Tag_ != null &&  tierObj.Location_Tag_  != '' &&  tierObj.Location_Tag_ != undefined ? true : false;
         }
        
         if(DiscountAppliedOn){
           // 1
           if(Location_Tag_s){
             // 2
            let DiscountAppliedOnTag = tierObj.DiscountAppliedON == 'Both_Store' || tierObj.DiscountAppliedON == 'Online_Store' ? true : false;
         
            let LocationObject = Object.keys(tierObj.Location_Tag_);
            if(LocationObject[0] == 'StoreLocation'){
            let StoreLocationcheck =  tierObj.Location_Tag_[LocationObject[0]].includes(globalFields.Storecountry) || tierObj.Location_Tag_[LocationObject[0]].includes(globalFields.Storecity) ? true : false;
            if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && DiscountAppliedOnTag && StoreLocationcheck) {
            var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
            getDates.valid; getDates.start_date; getDates.end_date;
            let timer_settings = parsed_timer_settings;                
            WriteTableHeading(tierObj);
            WriteTableRows(tierObj, selectedVariant);
              
                displayTiers.changePrice();
            if(timer_settings != undefined){                
              if(timer_settings.TimerStatus){  
                if(getDates.valid){
                    setInterval(function() { makeTimer(getDates.end_date); }, 1000);
                }
              }
          }
              jQuery('.shopify-payment-button__button').hide();
              setTimeout(function(){
                jQuery('.shopify-payment-button__button').hide();
              HideAdditionalPayments();
              }, 2000);
              setTimeout(function(){
                clearInterval(hide_buttons);
              }, 5000);
            } 
            }
            else{
              // 3
                 let TierLocation = tierObj.Location_Tag_[LocationObject[0]];
                 let CusotmerCountryLocation = globalFields.Customercountry;
                 let CusotmerCityLocation = globalFields.Customercity;
                 let CustomerLocationcheck_1 = (arr, arr1) =>{return arr.some(item => arr1.includes(item))};
                 let CustomerLocationcheck_2 = (arr2, arr3) =>{return arr2.some(item => arr3.includes(item))};
                 let CityValue = CustomerLocationcheck_1(TierLocation,CusotmerCountryLocation);
                 let CountryValue = CustomerLocationcheck_2(TierLocation,CusotmerCityLocation);
                
            if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && DiscountAppliedOnTag && (CityValue || CountryValue)) {
            var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
            getDates.valid; getDates.start_date; getDates.end_date;
            let timer_settings = parsed_timer_settings;                
            WriteTableHeading(tierObj);
            WriteTableRows(tierObj, selectedVariant);
            if(timer_settings != undefined){                
              if(timer_settings.TimerStatus){  
                if(getDates.valid){
                    setInterval(function() { makeTimer(getDates.end_date); }, 1000);
                }
              }
          }
              jQuery('.shopify-payment-button__button').hide();
              setTimeout(function(){
                jQuery('.shopify-payment-button__button').hide();
              HideAdditionalPayments();
              }, 2000);
              setTimeout(function(){
                clearInterval(hide_buttons);
              }, 5000);
            } 
             }
        
            }
           else{
             // 4
            if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && (tierObj.DiscountAppliedON == 'Both_Store' || tierObj.DiscountAppliedON == 'Online_Store')) {
            var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
            getDates.valid; getDates.start_date; getDates.end_date;
            let timer_settings = parsed_timer_settings;                
            WriteTableHeading(tierObj);
            WriteTableRows(tierObj, selectedVariant);
              displayTiers.changePrice();
            if(timer_settings != undefined){                
              if(timer_settings.TimerStatus){  
                if(getDates.valid){
                    setInterval(function() { makeTimer(getDates.end_date); }, 1000);
                }
              }
          }
              jQuery('.shopify-payment-button__button').hide();
              setTimeout(function(){
                jQuery('.shopify-payment-button__button').hide();
              HideAdditionalPayments();
              }, 2000);
              setTimeout(function(){
                clearInterval(hide_buttons);
              }, 5000);
            } 
           }
         }
         else{
           // 5
           
            if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date)) {
            var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
            getDates.valid; getDates.start_date; getDates.end_date;
            let timer_settings = parsed_timer_settings;                
            WriteTableHeading(tierObj);
            WriteTableRows(tierObj, selectedVariant);
            displayTiers.changePrice();
            if(timer_settings != undefined){                
              if(timer_settings.TimerStatus){  
                if(getDates.valid){
                    setInterval(function() { makeTimer(getDates.end_date); }, 1000);
                }
              }
          }
              jQuery('.shopify-payment-button__button').hide();
              setTimeout(function(){
                jQuery('.shopify-payment-button__button').hide();
              HideAdditionalPayments();
              }, 2000);
              setTimeout(function(){
                clearInterval(hide_buttons);
              }, 5000);
            }else{
              displayTiers.changePrice();
            }
         }   
        }
        }, 200);
  
  }

  
  setTimeout(function(){
    clearInterval(hide_buttons);
  }, 10000);

  this.OnVariantChange = function () {
      setTimeout(function () {
           $(document).on('click', '.product-info variant-picker', function () {
              displayTiers.DisplayTiersFn();
            displayTiers.changePrice();
          });
      }, 1800);
  }



 this.OnQuantityChange = function () {
        setTimeout(function () {
            $('quantity-input .qty-input__input.input').keyup(function(){
              displayTiers.DisplayTiersFn();
                displayTiers.changePrice();
            });
            $('product-form .quantitySelect select[name="quantity"]').change(function(){
              setTimeout(function(){  
                displayTiers.DisplayTiersFn();
              	displayTiers.changePrice();
              },100);
            });
        }, 2000);
    }
  

    this.changePrice = function() {
        let currencyRate = Shopify.currency.rate;
        let priceOfProduct = 0

        currencyRate = Number(currencyRate);
        let currencySymbol_ = globalFields.currency_symbol;
        if (Shopify.currency.active == 'EUR') {
            currencySymbol_ = '€';
        } else if (Shopify.currency.active == 'USD') {
            currencySymbol_ = '$';
        }
      
        let priceDivided = 1;
        let vatIncExl = jQuery('.vatSwitchWrapper .vatSwitch .switch input[type="checkbox"]').prop('checked');
        if (vatIncExl) {
          priceDivided = 1.2;
        }

        // in that case when don't want to change the pdp price with other countries then uncomment below code and remove above if condition and uncomment a if condition on line number 359.
        // const exculdeMerketWithGBP = ["GG", "JE"];
        // if (Shopify.currency.active != 'GBP' || exculdeMerketWithGBP.includes(globalFields.currentIsoCode)) {
        //   priceDivided = 1.2;
        // } else if (Shopify.currency.active === 'GBP' && !exculdeMerketWithGBP.includes(globalFields.currentIsoCode) && vatIncExl) {
        //   priceDivided = 1.2;
        // }

      
        var selectedVariantcheck = jQuery('input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]', jQuery('form[action="/cart/add"]')).val();
        var originalPriceoffProdutcnew = globalFields.priceChangeFunc(selectedVariantcheck);
      if(originalPriceoffProdutcnew <= 0 )return
        priceOfProduct = Number(originalPriceoffProdutcnew/priceDivided)
      
        originalPriceoffProdutcnew = Number(originalPriceoffProdutcnew) 
        originalPriceoffProdutcnew = globalFields.formatMoney(originalPriceoffProdutcnew, globalFields.amount);

        // if (jQuery('table.ac__settings__table').length > 0) {
            var discountedQty = jQuery('table.ac__settings__table .ac__tr:last td:eq(0)').text().split('+')[0];
            discountedQty = Number(discountedQty);
            var quantityDropdownProduct = document.querySelectorAll('quantity-input .qty-input__input.input')[0];
            var selectedValueProduct = parseInt(quantityDropdownProduct.value);
            let originalChangeQty = selectedValueProduct;
            if (isNaN(originalChangeQty)) {
                originalChangeQty = 1;
            }

            var updatedItemPrice = 0;
            var selectedVariant = jQuery('input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]', jQuery('form[action="/cart/add"]')).val();
            if (selectedVariant == "") {
                let id_ = Object.keys(globalFieldsProductPage_AC.variantsPriceArray_PD);
                selectedVariant = id_[0];
            }

            var originalPriceoffProdutc = globalFields.priceChangeFunc(selectedVariant);
             originalPriceoffProdutc = Number(originalPriceoffProdutc/priceDivided) ;
           var quantityDropdownProduct =document.querySelectorAll('quantity-input .qty-input__input.input')[0];
            var quantity = parseInt(quantityDropdownProduct.value);
           let itemUnitPrice = originalPriceoffProdutc * quantity;
            itemUnitPrice = globalFields.formatMoney(itemUnitPrice, globalFields.amount);
            originalPriceoffProdutc = globalFields.formatMoney(originalPriceoffProdutc, globalFields.amount);
          
    
            if (selectedVariant != null && globalFieldsProductPage_AC.productMetafield != '[]' && globalFieldsProductPage_AC.productMetafield != undefined && selectedVariant != "") {
                var tierObj = globalFields.GetTierObject(globalFieldsProductPage_AC.productMetafield, selectedVariant);
                if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date)) {
                    for (i = 0; i < tierObj.tier_min.length; i++) {
                        var tierPrice = parseFloat(tierObj.tier_values[i]);
                        var minTier = parseInt(tierObj.tier_min[i]),
                            maxTier = tierObj.tier_max[i] != 'max' ? parseInt(tierObj.tier_max[i]) : tierObj.tier_max[i];
                        var updatedLinePrice = 0,
                            condition1 = false,
                            condition2 = false;
    
                       var originalPrice_ = originalPriceoffProdutc.split(currencySymbol_)[1];
                       originalPriceoffProdutcnew = globalFields.priceChangeFunc(selectedVariantcheck);
                       originalPriceoffProdutcnew = Number(originalPriceoffProdutcnew) 
                       originalPrice_ = originalPriceoffProdutcnew/100;
                       originalPrice_ = Number(originalPrice_);
    
                        condition1 = originalChangeQty >= minTier;
                        condition2 = maxTier == "max" || originalChangeQty <= maxTier;
                        if (condition1 && condition2) {
                            break;
                        }
                    }

                    if (condition1 && condition2) {
                        if (tierObj.discount_type == 'percentage') {
                            var originalPriceCut = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(originalPrice_)));
                            updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(originalPrice_) - originalPriceCut);
                        } else if (tierObj.discount_type == 'fixed') {
                            updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(originalPrice_) - parseFloat(tierPrice));
                        } else if (tierObj.discount_type == 'fixed_price') {
                            updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice));
                        }
                      var quantityDropdownProduct =document.querySelectorAll('quantity-input .qty-input__input.input')[0];
                      var selectedValueProduct = parseInt(quantityDropdownProduct.value);
                      let quantity = selectedValueProduct;

                     
                     let discountTierValue = Number(updatedItemPrice * currencyRate);
                     let devidedDiscountedAmount = discountTierValue/priceDivided;
                      
                     let discountAmountValue = Number(devidedDiscountedAmount.toFixed(2));
                      // in that case when don't want to change the pdp price with other countries
                      // if(exculdeMerketWithGBP.includes(globalFields.currentIsoCode)){
                      //   discountAmountValue = Number(devidedDiscountedAmount);
                      // }

                     if((discountAmountValue >= priceOfProduct/100 )){
                        quantity = (discountAmountValue * Number(quantity));
                        quantity = globalFields.formatMoney(Number(quantity*100), globalFields.amount);
                        updatedItemPrice = globalFields.formatMoney((Number(discountAmountValue*100)), globalFields.amount);
                     } else {
                        quantity = discountAmountValue * Number(quantity);
                        quantity = globalFields.formatMoney(Number(quantity*100), globalFields.amount);
                        updatedItemPrice = globalFields.formatMoney((Number(updatedItemPrice/priceDivided * currencyRate)).toFixed(2), globalFields.amount);
                     }
                     jQuery('.custom-row').remove();
                     jQuery('.product-info .price__default .price__current').hide();
                     // jQuery('.product-info .price__default .price__current').html(`<p class="price_range anncode" id="price_ppr"><span class="money pre-money" data-product-id="${globalFields.ProductOrinalId}" style="visibility: visible;display: none;">${updatedItemPrice}</span><span> ${quantity}</span><p>`);
                     jQuery('.product-info .price__default .price__current').before(`<div class="custom-row"><div class="custom-col" data-product-id="${globalFields.ProductOrinalId}"><div class="custom-product-label">Your Pack Price</div><div class="custom-product-amount"><span>${updatedItemPrice}</span></div></div><div class="custom-col"><div class="custom-product-label">Total Price</div><div class="custom-product-amount"><span>${quantity}</span></div></div></div>`)
                    } else {
                      
                      jQuery('.custom-row').remove();
                      jQuery('.product-info .price__default .price__current').hide();
                      jQuery('.product-info .price__default .price__current').before(`<div class="custom-row"><div class="custom-col" data-product-id="${globalFields.ProductOrinalId}"><div class="custom-product-label">Your Pack Price</div><div class="custom-product-amount"><span>${originalPriceoffProdutc}</span></div></div><div class="custom-col"><div class="custom-product-label">Total Price</div><div class="custom-product-amount"><span>${itemUnitPrice}</span></div></div></div>`)
                    
                    }
                } else {
                    jQuery('.custom-row').remove();
                        jQuery('.product-info .price__default .price__current').hide();
                    jQuery('.product-info .price__default .price__current').before(`<div class="custom-row"><div class="custom-col" data-product-id="${globalFields.ProductOrinalId}"><div class="custom-product-label">Your Pack Price</div><div class="custom-product-amount"><span>${originalPriceoffProdutc}</span></div></div><div class="custom-col"><div class="custom-product-label">Total Price</div><div class="custom-product-amount"><span>${itemUnitPrice}</span></div></div></div>`)
                }
            } else {
                 jQuery('.custom-row').remove();
                        jQuery('.product-info .price__default .price__current').hide();
                jQuery('.product-info .price__default .price__current').before(`<div class="custom-row"><div class="custom-col" data-product-id="${globalFields.ProductOrinalId}"><div class="custom-product-label">Your Pack Price</div><div class="custom-product-amount"><span>${originalPriceoffProdutc}</span></div></div><div class="custom-col"><div class="custom-product-label">Total Price</div><div class="custom-product-amount"><span>${itemUnitPrice}</span></div></div></div>`)
            }
        
    };


  var TableHeadHtml = function (contentHtml, tableSelector, position) {
      jQuery(tableSelector).before(contentHtml)
    $('#ac_table3').hide();
  }
  
  var WriteTableHeading = function (tierObj) {
    var tableSelector = '.product-info .product-info__add-to-cart';
      if (globalFields.settings.selected_table == "table1") {
          TableHeadHtml('<table class="ac__settings__table ac_table1"  id="ac_table1"><tbody class="ac__tbody"><tr class="ac__tr ac__tr1"><th class="ac__th ac__th1">' + globalFields.settings.table_headers.header1_value + '</th><th class="ac__th ac__th2">' + globalFields.settings.table_headers.header2_value + '</th><th class="ac__th ac__th2">' + globalFields.settings.table_headers.header3_value + '</th></tr></tbody></table>', tableSelector);
      }
      if (globalFields.settings.selected_table == "table2") {

          TableHeadHtml('<table class="ac__settings__table ac_table2" id="ac_table2"><tbody class="ac__tbody"><tr class="ac__tr ac__tr1"><th class="ac__th ac__th1">' + globalFields.settings.table_headers.header1_value + '</th><th class="ac__th ac__th2">' + globalFields.settings.table_headers.header2_value + '</th><th class="ac__th ac__th3">' + globalFields.settings.table_headers.header3_value + '</th></tr></tbody></table>', tableSelector);
      }

      if (globalFields.settings.selected_table == "table3") {
          TableHeadHtml('<table class="ac__settings__table ac_table3" id="ac_table3"><tbody class="ac__tbody"><tr class="ac__tr ac__tr1"><th class="ac__th ac__th1">' + globalFields.settings.table_headers.header1_value + '</th><th class="ac__th ac__th2">' + globalFields.settings.table_headers.header2_value + '</th><th class="ac__th ac__th3">' + globalFields.settings.table_headers.header3_value + '</th></tr></tbody></table>', tableSelector);
      }

      if (globalFields.settings.selected_table == "table4") {
          TableHeadHtml('<table class="ac__settings__table ac_table4" id="ac_table4"><tbody class="ac__tbody"></tbody></table>', tableSelector);
      }
  }

  var TableRowHtml = function (contentHtml, tableSelector) {
      jQuery(tableSelector).append(contentHtml);
  }

  var TableRowSingle = function (tieredMin_, tieredMax_, discountedPrice, tieredOff, index,itemtotalPrice) {
      var plusSign = tieredMin_ == tieredMax_ ? '' : '+', buyText = 'Buy ';
      var priceHtml = '<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + discountedPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(discountedPrice, globalFields.amount) + '</span>';
      if (globalFields.settings.selected_table == "table1") {
          TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + plusSign + '</td><td class="ac__td ac__td2">' + tieredOff + '</td><td class="ac__td ac__td2">' +itemtotalPrice + '</td></tr>', '#ac_table1 .ac__tbody');
      }

      if (globalFields.settings.selected_table == "table2") {
          TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + '</td><td class="ac__td ac__td2">' + tieredMax_ + '</td><td class="ac__td ac__td3">' + tieredOff + '</td></tr>', '#ac_table2 .ac__tbody');
      }

      if (globalFields.settings.selected_table == "table3") {
          TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + plusSign + '</td><td class="ac__td ac__td2">' + tieredOff + '</td><td class="ac__td ac__td3">' + itemtotalPrice + '</td></tr>', '#ac_table3 .ac__tbody');
      }

      if (globalFields.settings.selected_table == "table4") {
          var quantityTextTable4 = tieredMin_ + "-" + tieredMax_;
          if (tieredMax_ == "+") {
              quantityTextTable4 = tieredMin_ + "+";
          }
          TableRowHtml('<tr class="ac__tr ac__tr' + index + '"> <td class="ac__td ac__td1">' + globalFields.settings.table_body.body1_value + ' ' + tieredMin_ + ' ' + globalFields.settings.table_body.body2_value + ' ' + tieredOff + '</td></tr>', '#ac_table4');
      }


  }

  var WriteTableRows = function (tierObj, selectedVariant_) {
    let priceDivided = 1;
    let currencyRate = Number(Shopify.currency.rate);
        let vatIncExl = jQuery('.vatSwitchWrapper .vatSwitch .switch input[type="checkbox"]').prop('checked');
        if (vatIncExl) {
          priceDivided = 1.2;
        }
    
      var originalPrice_ = globalFieldsProductPage_AC.variantsPriceArray_PD[selectedVariant_]; originalPrice_ = originalPrice_ / 100;
    originalPrice_ = originalPrice_/priceDivided
        if(originalPrice_ <= 0 ){
          $('#ac_table3').hide();
          return
        }
      for (i = 0; i < tierObj.tier_min.length; i++) {
          var isBreakLoop = false, tieredOff = Number(tierObj.tier_values[i]);
          var tieredMin_ = parseInt(tierObj.tier_min[i]), tieredMax_ = tierObj.tier_max[i], discountedPrice = 0;

          if (tieredMax_ != "max") {
              tieredMax_ = parseInt(tieredMax_);
          }
          else {
              tieredMax_ = "+";
          }

          if (tierObj.discount_type == "percentage") {
              discountedPrice = Number(originalPrice_.toFixed(2));
              var p = parseFloat(tieredOff) / 100, originalPriceCut_ = Number(parseFloat(p * discountedPrice).toFixed(2));
              discountedPrice = discountedPrice - originalPriceCut_;
              if (discountedPrice <= 0) {
                  discountedPrice = 0;
                  tieredOff = "100%";
                  isBreakLoop = true;
                  tieredMax_ = "+";
              }
              else {
                  discountedPrice = discountedPrice.toFixed(2);
                  tieredOff = tieredOff + "% OFF";
              }
          }
          else if (tierObj.discount_type == "fixed_price") {
              discountedPrice = tieredOff.toFixed(2);
              tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount);
          }
          else {
              discountedPrice = Number((originalPrice_ - tieredOff).toFixed(2));
              if (discountedPrice <= 0) {
                  discountedPrice = 0;
                  tieredOff = globalFields.formatMoney(originalPrice_.toFixed(2), globalFields.amount);
                  isBreakLoop = true;
                  tieredMax_ = "+";
              }
              else {
                  discountedPrice = discountedPrice.toFixed(2);
                  tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount) + " OFF";
              }
          }
                      let quantity = tieredMin_;
                     let discountTierValue = Number(discountedPrice * currencyRate);
                     let devidedDiscountedAmount = tierObj.discount_type == "fixed_price" ? discountTierValue/priceDivided :discountTierValue;
                      
                     let discountAmountValue = Number(devidedDiscountedAmount.toFixed(2));
                      // in that case when don't want to change the pdp price with other countries
                      // if(exculdeMerketWithGBP.includes(globalFields.currentIsoCode)){
                      //   discountAmountValue = Number(devidedDiscountedAmount);
                      // }

                     if((discountAmountValue >= originalPrice_/100 )){
                        quantity = (discountAmountValue * Number(quantity));
                        quantity = globalFields.formatMoney(Number(quantity*100), globalFields.amount);
                        discountedPrice = globalFields.formatMoney((Number(discountAmountValue*100)), globalFields.amount);
                     } else {
                        quantity = discountAmountValue * Number(quantity);
                        quantity = globalFields.formatMoney(Number(quantity*100), globalFields.amount);
                        discountedPrice = globalFields.formatMoney((Number(discountedPrice/priceDivided * currencyRate)).toFixed(2), globalFields.amount);
                     }
             tieredOff = discountedPrice
          TableRowSingle(tieredMin_, tieredMax_, discountedPrice, tieredOff, i + 1,quantity);

          if (isBreakLoop) { break; }
      }
  }

}

var globalFieldsProductPage_AC = new ACDiscountApp.PDPage.Global(), displayTiers = new ACDiscountApp.PDPage.DisplayTiers();
displayTiers.DisplayTiersFn(); displayTiers.OnVariantChange();displayTiers.OnQuantityChange();
window.addEventListener('load', function () { 
displayTiers.changePrice();
        jQuery('.vatSwitchWrapper .vatSwitch .switch input[type="checkbox"]').click(function(e) {
          
          displayTiers.DisplayTiersFn(); displayTiers.OnVariantChange();displayTiers.OnQuantityChange();
    });
  setTimeout(function(){
displayTiers.changePrice(); displayTiers.OnVariantChange();

},6000); 
})